module.exports = {

    'common' : {
        'noResults' : 'No search result found',
        'btnConfirm' : '¿Are you sure?',
    },

    'labels' : {
        'choice_city'   : 'Select  city',
        'choice_event'  : 'Select an event',
        'choice_default': 'Type or select one',
    },

    'calendar' : {
        'eventAdd'         : 'Event added',
        'eventRefused'     : 'Event refused',
        'addToCalendar'    : 'add to my calendar',
        'noSuggestMore'    : 'Do not suggest again',
        'eventDates'       : '{0} to {1}',

        'titles' : {
            'suggested'         : 'Suggested trade shows',
            'searchByName'      : 'Filter trade show by name',
            'searchByGeo'       : 'Filter trade show by country',
            'addTradeshows'     : 'Add your upcoming trade shows',
            'nextTradeshows'    : 'Upcoming trades shows where you have contracted stands'
        },

        'buttons' : {
            'addTradeshows'     : 'Add trade show',
            'filter'            : 'Filter',
            'myTradeshows'      : 'My trade shows',
            'filterByLocation'  : 'Filter by location',
            'filterByName'      : 'Filter by name',
            'addToCalendar'     : 'add to my calendar',
        },

        'labels' : {
            'where' : 'Where',
            'begin' : 'From',
            'end'   : 'Until',
            'filterByCity'  : 'Filter by city',
            'filterByCity2' : 'City where the event takes place',
            'filterByMonth' : 'Indicate the beginning month',
            'filterByDates' : 'Dates'
        },

        'text' : {
            'suggested'                 : 'Based on the records regarding the trade shows in which you have worked and the main ones in your country, here is a selection of exhibitions in which you might plan to work. If so, please add them to your calendar!',
            'suggestedBy'               : 'Suggested trade shows based on',
            'suggestedByHistory'        : 'My record as a stand builder',
            'suggestedByLeads'          : 'Accepted leads ',
            'suggestedByNearlyEvents'   : 'Trade shows in 100Km radius',
            'suggestedByRelevantEvents' : 'Relevant trade shows in  800Km',
            'notFindEvent'              : 'We haven’t found {0} in our calendar. Tell us where and when is happening so that we can add to your calendar.',
            'workIndicated'             : 'You have indicated that you might work:',
            'confirmEvent'              : 'confirm trade show',
            'myHistoryExplanation'      : 'We suggest trade shows in which we know you already worked for in the past or have shown interest in working on them.',
            'acceptedLeadsExplanation'  : 'We suggest those trade shows in which you have accepted leads.',
            'relevantEventsExplanation' : 'We display the upcoming trade shows that are held in an {0} Km radius from your head quarters.',
            'suggestedExplanation'      : 'Select those in which you will work in the next edition.',


        },
    },
};




// WEBPACK FOOTER //
// ./resources/js/i18n/calendar/en.js